"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pilotNotesSyncServiceFactory = exports.PilotNotesSyncServiceImpl = void 0;
var syncConflictUtils_1 = require("./syncConflictUtils");
var fieldAllowlist_1 = require("./fieldAllowlist");
var API_BASE = '/api/v2/pilot-notes';
var FOCUS_API_BASE = '/api/v2/focus';
/** Mirror person.service updateResultRow allowlist (PHP updateRowAction). */
var UPDATE_ROW_ALLOWED_KEYS = [
    'ID',
    'pnBody',
    'pnAccount',
    'pnUserRealm',
    'pnAssetAccount',
    'pnAssetRealm',
    'pnAssetTag',
    'pnAssetTagAux',
    'pnUserRoamHint',
    'pnUserRoamPoint',
    'pnUserRoamGeoLat',
    'pnUserRoamGeoLon',
    'pnValue',
    'pnValueUnit',
    'pnParentFK',
    'pnParentAddFK',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnSchedule',
    'pnShareLevel',
    'pnCustomTimeUTC',
    'pnCompletedUTC',
    'pnCompletedPersonPK',
    'pnItemCode',
    'pnInvoiceNote',
];
var UPDATE_REPLY_ALLOWED_KEYS = [
    'ID',
    'pnBody',
    'pnValue',
    'pnValueUnit',
    'pnAssetTag',
    'pnAssetTagAux',
    'pnAssetAccount',
    'pnAssetRealm',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnItemCode',
    'pnParentFK',
    'saveReply',
    'ReplyAsSchedule',
    'ReplyAsAssignedTo',
    'ReplyAsPeer',
    'doneCheck',
];
var UPDATE_ROW_ARRAY_ALLOWED_KEYS = [
    'ID',
    '__closeAtNextStamp',
    '__applyAutoEnd',
    '__clearAutoEnd',
    '__clearCompleted',
];
function cleanEditFields(edit) {
    return (0, fieldAllowlist_1.pickAllowedFieldsOrThrow)(edit, UPDATE_ROW_ALLOWED_KEYS, 'edit');
}
var PilotNotesSyncServiceImpl = /** @class */ (function () {
    function PilotNotesSyncServiceImpl($http, $q, $window) {
        this.$http = $http;
        this.$q = $q;
        this.$window = $window;
    }
    PilotNotesSyncServiceImpl.prototype.buildUpdateRowPayload = function (row) {
        var payload = {};
        if (row.edit && typeof row.edit === 'object') {
            payload.row = cleanEditFields(row.edit);
        }
        if (row.rowArray && typeof row.rowArray === 'object') {
            payload.rowArray = (0, fieldAllowlist_1.pickAllowedFieldsOrThrow)(row.rowArray, UPDATE_ROW_ARRAY_ALLOWED_KEYS, 'rowArray');
        }
        if (row.reply && typeof row.reply === 'object') {
            payload.reply = (0, fieldAllowlist_1.pickAllowedFieldsOrThrow)(row.reply, UPDATE_REPLY_ALLOWED_KEYS, 'reply');
        }
        return payload;
    };
    PilotNotesSyncServiceImpl.prototype.extractBaseRowUpdatedAt = function (row) {
        var _a, _b, _c, _d;
        var edit = row.edit;
        var candidate = (_d = (_c = (_b = (_a = edit === null || edit === void 0 ? void 0 : edit._syncBaseUpdatedAt) !== null && _a !== void 0 ? _a : row._syncBaseUpdatedAt) !== null && _b !== void 0 ? _b : edit === null || edit === void 0 ? void 0 : edit.pnUpdated) !== null && _c !== void 0 ? _c : row.pnUpdated) !== null && _d !== void 0 ? _d : null;
        if (candidate === null || candidate === undefined || candidate === '') {
            return null;
        }
        if (candidate instanceof Date) {
            return candidate.toISOString();
        }
        return String(candidate);
    };
    PilotNotesSyncServiceImpl.prototype.syncQueueEntry = function (entry) {
        var _a;
        var syncEntry = {
            client_entry_id: entry.id,
            operation_kind: entry.kind,
            entry_timestamp: entry.createdAt,
            base_row_updated_at: (_a = entry.baseRowUpdatedAt) !== null && _a !== void 0 ? _a : null,
            payload: entry.kind === 'updateRow'
                ? this.buildUpdateRowPayload(entry.payload)
                : entry.payload,
        };
        return this.syncEntries([syncEntry]).then(function (response) {
            var result = response.results[0];
            if (!result) {
                throw new Error('Pilot notes sync returned no result');
            }
            if (result.status === 'applied' || result.status === 'duplicate') {
                return result;
            }
            if (result.status === 'conflict') {
                throw new syncConflictUtils_1.PilotNotesSyncConflictError(result);
            }
            var message = result.error || "Pilot notes sync failed with status ".concat(result.status);
            throw new Error(message);
        });
    };
    PilotNotesSyncServiceImpl.prototype.syncEntries = function (entries) {
        if (!entries.length) {
            return this.$q.resolve({
                success: true,
                processed: 0,
                duplicates: 0,
                conflicts: 0,
                errors: 0,
                results: [],
            });
        }
        return this.$http
            .post("".concat(API_BASE, "/sync"), {
            entries: entries,
            device_id: this.getDeviceId(),
        })
            .then(function (response) { return response.data; });
    };
    PilotNotesSyncServiceImpl.prototype.getRowHistory = function (rowId, limit) {
        if (limit === void 0) { limit = 50; }
        return this.$http
            .get("".concat(API_BASE, "/history"), {
            params: { row_id: rowId, limit: limit },
        })
            .then(function (response) { var _a, _b; return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.entries) !== null && _b !== void 0 ? _b : []; });
    };
    PilotNotesSyncServiceImpl.prototype.setTime = function (rowId, options) {
        var _this = this;
        if (!rowId) {
            return this.$q.reject(new Error('Missing row ID for setTime'));
        }
        var body = {};
        if (options === null || options === void 0 ? void 0 : options.setToNow) {
            body.set_to_now = true;
        }
        if ((options === null || options === void 0 ? void 0 : options.backdateMinutes) !== undefined && (options === null || options === void 0 ? void 0 : options.backdateMinutes) !== null) {
            var mins = typeof options.backdateMinutes === 'string'
                ? parseInt(options.backdateMinutes, 10)
                : options.backdateMinutes;
            if (!mins || mins <= 0 || Number.isNaN(mins)) {
                return this.$q.reject(new Error('backdate minutes must be a positive integer'));
            }
            body.backdate_minutes = mins;
        }
        if (options === null || options === void 0 ? void 0 : options.endFromNext) {
            body.end_from_next = true;
        }
        if (options === null || options === void 0 ? void 0 : options.completeNow) {
            body.complete_now = true;
        }
        if (!Object.keys(body).length) {
            return this.$q.reject(new Error('setTime requires setToNow, backdateMinutes, endFromNext, or completeNow'));
        }
        return this.$http
            .post("".concat(API_BASE, "/").concat(rowId, "/set-time"), body)
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Set time failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.patchFields = function (rowId, fields) {
        var _this = this;
        if (!rowId) {
            return this.$q.reject(new Error('Missing row ID for patchFields'));
        }
        if (!fields || typeof fields !== 'object' || !Object.keys(fields).length) {
            return this.$q.reject(new Error('patchFields requires a non-empty fields object'));
        }
        return this.$http
            .post("".concat(API_BASE, "/").concat(rowId, "/fields"), { fields: fields })
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Field update failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.getFocusState = function () {
        var _this = this;
        return this.$http.get("".concat(FOCUS_API_BASE, "/state")).then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Focus state load failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.setFocusContext = function (options) {
        var _this = this;
        var account = (options === null || options === void 0 ? void 0 : options.account) != null && String(options.account).trim()
            ? String(options.account).trim()
            : null;
        var realm = (options === null || options === void 0 ? void 0 : options.realm) != null && String(options.realm).trim()
            ? String(options.realm).trim()
            : null;
        if (!account && !realm) {
            return this.$q.reject(new Error('setFocusContext requires account or realm'));
        }
        var body = {};
        if (account)
            body.account = account;
        if (realm)
            body.realm = realm;
        return this.$http
            .post("".concat(FOCUS_API_BASE, "/set-context"), body)
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Set focus context failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.startFocusT = function (options) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var body = {
            parent_id: (_a = options === null || options === void 0 ? void 0 : options.parentId) !== null && _a !== void 0 ? _a : null,
            task_group: (options === null || options === void 0 ? void 0 : options.taskGroup) || 'Activity',
            topic_group: (options === null || options === void 0 ? void 0 : options.topicGroup) || 'Start',
            topic_detail: (_b = options === null || options === void 0 ? void 0 : options.topicDetail) !== null && _b !== void 0 ? _b : null,
            body: (_c = options === null || options === void 0 ? void 0 : options.body) !== null && _c !== void 0 ? _c : null,
            asset_tag: (_d = options === null || options === void 0 ? void 0 : options.assetTag) !== null && _d !== void 0 ? _d : null,
            asset_tag_aux: (_e = options === null || options === void 0 ? void 0 : options.assetTagAux) !== null && _e !== void 0 ? _e : null,
            asset_account: (_g = (_f = options === null || options === void 0 ? void 0 : options.assetAccount) !== null && _f !== void 0 ? _f : options === null || options === void 0 ? void 0 : options.account) !== null && _g !== void 0 ? _g : null,
            asset_realm: (_j = (_h = options === null || options === void 0 ? void 0 : options.assetRealm) !== null && _h !== void 0 ? _h : options === null || options === void 0 ? void 0 : options.realm) !== null && _j !== void 0 ? _j : null,
            account: (_l = (_k = options === null || options === void 0 ? void 0 : options.account) !== null && _k !== void 0 ? _k : options === null || options === void 0 ? void 0 : options.assetAccount) !== null && _l !== void 0 ? _l : null,
            realm: (_o = (_m = options === null || options === void 0 ? void 0 : options.realm) !== null && _m !== void 0 ? _m : options === null || options === void 0 ? void 0 : options.assetRealm) !== null && _o !== void 0 ? _o : null,
        };
        if ((options === null || options === void 0 ? void 0 : options.itemCode) != null && options.itemCode !== '') {
            body.item_code = options.itemCode;
        }
        return this.$http
            .post("".concat(FOCUS_API_BASE, "/start-t"), body)
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Start focus T failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        })
            .catch(function (err) {
            var d = err && err.data;
            var message = (d && (d.Message || d.message || d.error)) ||
                (err && err.message) ||
                'Start focus T failed';
            return _this.$q.reject(new Error(String(message)));
        });
    };
    PilotNotesSyncServiceImpl.prototype.adoptFocusT = function (rowId, opts) {
        var _this = this;
        var id = Number(rowId);
        if (!id || id <= 0) {
            return this.$q.reject(new Error('Invalid row id'));
        }
        var body = {
            row_id: id,
            reopen: (opts === null || opts === void 0 ? void 0 : opts.reopen) === true,
            close_previous: (opts === null || opts === void 0 ? void 0 : opts.closePrevious) !== false,
        };
        return this.$http.post("".concat(FOCUS_API_BASE, "/adopt-t"), body).then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Adopt focus T failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.startFocusS = function (options) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        // Empty topic by default — do not stamp "Shift" (commercial T&A later if needed)
        var topicGroup = (options === null || options === void 0 ? void 0 : options.topicGroup) != null ? String(options.topicGroup) : '';
        var body = {
            task_group: (options === null || options === void 0 ? void 0 : options.taskGroup) || 'Session',
            topic_group: topicGroup,
            topic_detail: (options === null || options === void 0 ? void 0 : options.topicDetail) || 'Start',
            body: (_a = options === null || options === void 0 ? void 0 : options.body) !== null && _a !== void 0 ? _a : null,
            account: (_b = options === null || options === void 0 ? void 0 : options.account) !== null && _b !== void 0 ? _b : null,
            realm: (_c = options === null || options === void 0 ? void 0 : options.realm) !== null && _c !== void 0 ? _c : null,
            asset_tag: (_d = options === null || options === void 0 ? void 0 : options.assetTag) !== null && _d !== void 0 ? _d : null,
            asset_tag_aux: (_e = options === null || options === void 0 ? void 0 : options.assetTagAux) !== null && _e !== void 0 ? _e : null,
            asset_account: (_f = options === null || options === void 0 ? void 0 : options.assetAccount) !== null && _f !== void 0 ? _f : null,
            asset_realm: (_g = options === null || options === void 0 ? void 0 : options.assetRealm) !== null && _g !== void 0 ? _g : null,
        };
        if ((options === null || options === void 0 ? void 0 : options.parentId) != null && Number(options.parentId) > 0) {
            body.parent_id = Number(options.parentId);
        }
        if ((options === null || options === void 0 ? void 0 : options.itemCode) != null && options.itemCode !== '') {
            body.item_code = options.itemCode;
        }
        return this.$http
            .post("".concat(FOCUS_API_BASE, "/start-s"), body)
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Start focus S failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        })
            .catch(function (err) {
            // Already an Error from the then-branch (Result !== OK)
            if (err instanceof Error && err.message && !/status code/i.test(err.message)) {
                return _this.$q.reject(err);
            }
            var d = err && err.data;
            var message = (d && (d.Message || d.message || d.error)) ||
                (err && err.message) ||
                'Start focus S failed';
            return _this.$q.reject(new Error(String(message)));
        });
    };
    /**
     * Peel outermost Focus timer (T if open, else S). No Finish stamp row.
     * Optional labels are ignored by the API (compat only).
     */
    PilotNotesSyncServiceImpl.prototype.signOffFocus = function (options) {
        var _this = this;
        var body = {};
        if ((options === null || options === void 0 ? void 0 : options.body) != null) {
            body.body = options.body;
        }
        return this.$http.post("".concat(FOCUS_API_BASE, "/sign-off"), body).then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Sign off failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.sealFocusT = function (options) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var body = {
            task_group: (options === null || options === void 0 ? void 0 : options.taskGroup) || 'Session',
            topic_group: (options === null || options === void 0 ? void 0 : options.topicGroup) || 'Travel',
            topic_detail: (_a = options === null || options === void 0 ? void 0 : options.topicDetail) !== null && _a !== void 0 ? _a : null,
            body: (_b = options === null || options === void 0 ? void 0 : options.body) !== null && _b !== void 0 ? _b : null,
            asset_tag: (_c = options === null || options === void 0 ? void 0 : options.assetTag) !== null && _c !== void 0 ? _c : null,
            asset_tag_aux: (_d = options === null || options === void 0 ? void 0 : options.assetTagAux) !== null && _d !== void 0 ? _d : null,
            asset_account: (_e = options === null || options === void 0 ? void 0 : options.assetAccount) !== null && _e !== void 0 ? _e : null,
            asset_realm: (_f = options === null || options === void 0 ? void 0 : options.assetRealm) !== null && _f !== void 0 ? _f : null,
        };
        if ((options === null || options === void 0 ? void 0 : options.itemCode) != null && options.itemCode !== '') {
            body.item_code = options.itemCode;
        }
        return this.$http.post("".concat(FOCUS_API_BASE, "/seal-t"), body).then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Seal Focus T failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.unlinkFocusTimer = function (rowId, opts) {
        var _this = this;
        if (!rowId) {
            return this.$q.reject(new Error('Missing row ID for unlinkFocusTimer'));
        }
        var body = {
            row_id: rowId,
            clear_end: (opts === null || opts === void 0 ? void 0 : opts.clearEnd) !== false,
            mark_unreliable: !!(opts === null || opts === void 0 ? void 0 : opts.markUnreliable),
        };
        return this.$http
            .post("".concat(FOCUS_API_BASE, "/unlink-timer"), body)
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Unlink timer failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.sealFocusShort = function (rowId, durationMinutes) {
        var _this = this;
        if (!rowId) {
            return this.$q.reject(new Error('Missing row ID for sealFocusShort'));
        }
        var mins = Number(durationMinutes);
        if (!mins || mins <= 0) {
            return this.$q.reject(new Error('durationMinutes must be positive'));
        }
        return this.$http
            .post("".concat(FOCUS_API_BASE, "/seal-short"), {
            row_id: rowId,
            duration_minutes: mins,
        })
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Seal short failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.promoteTNotes = function (rowId, options) {
        var _this = this;
        if (!rowId) {
            return this.$q.reject(new Error('Missing row ID for promoteTNotes'));
        }
        var body = {
            parent_kind: (options === null || options === void 0 ? void 0 : options.parentKind) || 'document',
            stub_t_body: (options === null || options === void 0 ? void 0 : options.stubTBody) !== false,
        };
        if ((options === null || options === void 0 ? void 0 : options.caption) != null && String(options.caption).trim()) {
            body.caption = String(options.caption).trim();
        }
        return this.$http
            .post("".concat(API_BASE, "/").concat(rowId, "/promote-t-notes"), body)
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Promote notes failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.outlineNewTask = function (documentId, options) {
        var _this = this;
        if (!documentId) {
            return this.$q.reject(new Error('Missing document ID for outlineNewTask'));
        }
        var label = (options === null || options === void 0 ? void 0 : options.label) != null ? String(options.label).trim() : '';
        if (!label) {
            return this.$q.reject(new Error('outlineNewTask requires a label'));
        }
        return this.$http
            .post("".concat(API_BASE, "/").concat(documentId, "/outline-new-task"), {
            label: label,
            schedule: !!(options === null || options === void 0 ? void 0 : options.schedule),
        })
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Outline new task failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.stuffTaskCaption = function (taskId, options) {
        var _this = this;
        var _a, _b;
        if (!taskId) {
            return this.$q.reject(new Error('Missing task ID for stuffTaskCaption'));
        }
        return this.$http
            .post("".concat(API_BASE, "/").concat(taskId, "/stuff-caption"), {
            expected_body: (_a = options === null || options === void 0 ? void 0 : options.expectedBody) !== null && _a !== void 0 ? _a : '',
            new_body: (_b = options === null || options === void 0 ? void 0 : options.newBody) !== null && _b !== void 0 ? _b : '',
        })
            .then(function (response) {
            var data = response.data;
            // OK / SKIP / NOOP are all soft-success
            if (!data || !data.Result) {
                return _this.$q.reject(new Error('Stuff caption failed'));
            }
            if (data.Result === 'ERROR' || data.Result === 'AUTH') {
                var message = data.Message || data.error || 'Stuff caption failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.moveUpParent = function (rowId) {
        var _this = this;
        if (!rowId) {
            return this.$q.reject(new Error('Missing row ID for moveUpParent'));
        }
        return this.$http
            .post("".concat(API_BASE, "/").concat(rowId, "/move-up"), {})
            .then(function (response) {
            var data = response.data;
            if (!data || data.Result !== 'OK') {
                var message = (data === null || data === void 0 ? void 0 : data.Message) || (data === null || data === void 0 ? void 0 : data.error) || 'Move up failed';
                return _this.$q.reject(new Error(message));
            }
            return data;
        });
    };
    PilotNotesSyncServiceImpl.prototype.getDeviceId = function () {
        var key = 'audroam.device_id';
        var deviceId = this.$window.localStorage.getItem(key);
        if (!deviceId) {
            deviceId = "".concat(Date.now().toString(36)).concat(Math.random().toString(36).slice(2));
            this.$window.localStorage.setItem(key, deviceId);
        }
        return deviceId;
    };
    return PilotNotesSyncServiceImpl;
}());
exports.PilotNotesSyncServiceImpl = PilotNotesSyncServiceImpl;
exports.pilotNotesSyncServiceFactory = [
    '$http',
    '$q',
    '$window',
    function ($http, $q, $window) {
        return new PilotNotesSyncServiceImpl($http, $q, $window);
    },
];
